import { Avatar, Box, Button, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import Camera from 'assets/icons/camera.svg';
import { titleTextColor } from 'assets/styles/_palette';

export const ChangeImage = styled(Box)({
	...flexMixin({ direction: 'column' }),
	position: 'relative',
});

export const AvatarContainer = styled(Box)({
	position: 'relative',
	display: 'inline-block',
});

export const LoaderContainer = styled(Box)(({ theme }) => ({
	...flexMixin({}),
	width: '106px',
	height: '106px',
	[theme.breakpoints.down('sm')]: {
		width: '90px',
		height: '90px',
	},
	[theme.breakpoints.down('xs')]: {
		width: '80px',
		height: '80px',
	},
}));

export const Inputs = styled(Box)(({ theme }) => ({
	...flexMixin({ justify: 'flex-start', gap: 24, direction: 'column' }),
	flexWrap: 'wrap',
	width: '100%',
	[theme.breakpoints.down('sm')]: {
		gap: 16,
	},
	[theme.breakpoints.down('xs')]: {
		gap: 12,
	},
}));

export const ChangePassword = styled(Box)(({ theme }) => ({
	...flexMixin({ justify: 'space-between' }),
	width: '100%',
	[theme.breakpoints.down('sm')]: {
		flexDirection: 'column',
		gap: 12,
		alignItems: 'flex-start',
	},
	'& button': {
		width: '275px',
		padding: '10px 16px',
		borderRadius: '8px',
		border: '1px solid #4786FF',
		fontSize: '16px',
		fontWeight: '700',
		lineHeight: '157%',
		letterSpacing: '0.1px',
		textTransform: 'none',
		color: '#4786FF',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			fontSize: '14px',
			padding: '10px 12px',
		},
		[theme.breakpoints.down('xs')]: {
			fontSize: '14px',
			padding: '8px 12px',
		},
	},
}));

export const ChangePasswordInfo = styled(Box)(({ theme }) => ({
	...flexMixin({ direction: 'column', align: 'flex-start', gap: 4 }),
	'& h4': {
		fontSize: '16px',
		fontWeight: 700,
		lineHeight: '157%',
		letterSpacing: '0.1px',
		color: titleTextColor,
		[theme.breakpoints.down('sm')]: {
			fontSize: '14px',
		},
		[theme.breakpoints.down('xs')]: {
			fontSize: '14px',
		},
	},
	'& p': {
		[theme.breakpoints.down('sm')]: {
			fontSize: '14px',
		},
		[theme.breakpoints.down('xs')]: {
			fontSize: '13px',
		},
	},
}));

export const DeleteButton = styled(Button)(({ theme }) => ({
	...flexMixin({ gap: 8 }),
	width: '100%',
	borderRadius: '8px',
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: '157%',
	letterSpacing: '0.1px',
	textTransform: 'none',
	color: '#FB0B24',
	marginTop: 'auto',
	padding: '10px 16px',
	[theme.breakpoints.down('sm')]: {
		fontSize: '14px',
		padding: '10px 12px',
	},
	[theme.breakpoints.down('xs')]: {
		fontSize: '14px',
		padding: '8px 12px',
	},
	'& svg path': {
		fill: '#FB0B24',
	},
}));

export const UploadAvatar = styled(Box)(({ theme }) => ({
	...flexMixin({}),
	width: '106px',
	height: '106px',
	borderRadius: '50%',
	border: '1px dashed rgba(26, 36, 47, 0.20)',
	background: '#FAFAFA',
	cursor: 'pointer',
	[theme.breakpoints.down('sm')]: {
		width: '90px',
		height: '90px',
		'& svg': {
			height: '40px',
			width: '40px',
		},
	},
	[theme.breakpoints.down('xs')]: {
		width: '80px',
		height: '80px',
		'& svg': {
			height: '36px',
			width: '36px',
		},
	},
	'& svg': {
		height: '50px',
		width: '50px',
		'& path': {
			stroke: '#4786FF',
		},
	},
}));

export const UserAvatar = styled(Avatar)(({ theme }) => ({
	position: 'relative',
	width: '106px',
	height: '106px',
	borderRadius: '50%',
	[theme.breakpoints.down('sm')]: {
		width: '90px',
		height: '90px',
		'&::after': {
			width: '90px',
			height: '90px',
			backgroundSize: '40px 40px',
		},
	},
	[theme.breakpoints.down('xs')]: {
		width: '80px',
		height: '80px',
		'&::after': {
			width: '80px',
			height: '80px',
			backgroundSize: '36px 36px',
		},
	},
	'&:hover::after': {
		opacity: 1,
	},
	'&::after': {
		content: '""',
		opacity: 0,
		position: 'absolute',
		background: `url('${Camera}') center / cover  no-repeat, rgba(0, 0, 0, 0.5)`,
		backgroundSize: '50px 50px',
		width: '106px',
		height: '106px',
		borderRadius: '50%',
		transition: '0.4s',
		cursor: 'pointer',
	},
}));

export const DeleteIconButton = styled(Button)(({ theme }) => ({
	position: 'absolute',
	bottom: 0,
	right: 0,
	minWidth: '32px',
	width: '32px',
	height: '32px',
	padding: 0,
	borderRadius: '50%',
	backgroundColor: '#FB0B24',
	color: '#fff',
	'&:hover': {
		backgroundColor: '#d9091f',
	},
	'&:disabled': {
		backgroundColor: '#ccc',
	},
	[theme.breakpoints.down('sm')]: {
		minWidth: '28px',
		width: '28px',
		height: '28px',
		'& svg': {
			width: '16px',
			height: '16px',
		},
	},
	[theme.breakpoints.down('xs')]: {
		minWidth: '24px',
		width: '24px',
		height: '24px',
		'& svg': {
			width: '14px',
			height: '14px',
		},
	},
	'& svg': {
		width: '18px',
		height: '18px',
		'& path': {
			fill: '#fff',
		},
	},
}));
